import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors } from '@vds-core/theme';
var propTypes = {
  /**
   * @deprecated bottomLine
   */
  border: PropTypes.bool,

  /**
   * TableBody requires TableRow components as children.
   */
  children: PropTypes.node.isRequired,

  /**
   * @deprecated
   */
  className: PropTypes.string,

  /**
   * If provided, rows will change their background color when hovered over.
   */
  hasHover: PropTypes.bool,

  /**
   * @deprecated hasHover
   */
  hover: PropTypes.bool,

  /**
   * If provided, rows inside the Table component will have alternating stripes.
   */
  striped: PropTypes.bool,

  /**
   * If provided, rows inside the Table component will have bottom border.
   */
  bottomLine: PropTypes.bool,

  /**
   * @ignore
   * Object containing colors
   */
  colorConfig: PropTypes.object
};
var defaultProps = {
  border: true,
  className: undefined,
  hasHover: false,
  striped: false,
  hover: false,
  bottomLine: true,
  colorConfig: colors
};
var TableBody = /*#__PURE__*/styled.tbody.withConfig({
  displayName: "TableBody",
  componentId: "sc-1n0i1z5-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var hover = _ref.hover,
      hasHover = _ref.hasHover,
      striped = _ref.striped,
      colorConfig = _ref.colorConfig;

  if (striped) {
    var stripedCss = "\n        tr:nth-child(even) td {\n          background-color: ".concat(colorConfig.coolGray1, ";\n        }\n      ");

    if (hover || hasHover) {
      stripedCss += "\n          tr:hover td {\n            background-color: ".concat(colorConfig.coolGray1, ";\n          }\n        ");
    }

    return stripedCss;
  } else if (hover || hasHover) {
    return "\n        tr:hover {\n          background-color: ".concat(colorConfig.coolGray1, ";\n        }\n      ");
  }
}, function (_ref2) {
  var border = _ref2.border,
      bottomLine = _ref2.bottomLine;
  return !border || !bottomLine && "\n    tr {\n      border-color: transparent;\n    }\n  ";
});
TableBody.defaultProps = defaultProps;
TableBody.propTypes = propTypes;
TableBody.displayName = TableBody;
/**
 * @component
 */

export default TableBody;